import { Button } from '@/components/Button';
import { Input } from '@/components/Field';

export function ChatComposer({
  value,
  onChange,
  pending,
  onSend,
}: {
  value: string;
  onChange: (next: string) => void;
  pending: boolean;
  onSend: () => void;
}) {
  const disabled = pending;
  const trimmed = value.trim();

  return (
    <div className="flex gap-2 border-t border-slate-200 bg-card px-3 pt-2 pb-safe-2">
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!disabled && trimmed) onSend();
          }
        }}
        placeholder="Ask a question…"
        disabled={disabled}
        className="min-h-[40px] flex-1"
      />
      <Button
        variant="primary"
        onClick={() => {
          if (!disabled && trimmed) onSend();
        }}
        disabled={disabled || !trimmed}
        loading={pending}
        className="min-h-[40px] px-4"
      >
        Send
      </Button>
    </div>
  );
}
